/** Napi halmozott oszlopdiagram számításai. */
export interface NapiAdat { nap: string; megerositett: number; nem_megerositett: number }
export interface OszlopAdat extends NapiAdat {
  osszesen: number;
  /** A legmagasabb nap összegéhez viszonyított magasság, 0–100. */
  megerositettSzazalek: number;
  nemSzazalek: number;
}

export function oszlopAdatok(napi: readonly NapiAdat[]): OszlopAdat[] {
  const legnagyobb = Math.max(0, ...napi.map((n) => n.megerositett + n.nem_megerositett));
  const szaz = (x: number) => (legnagyobb > 0 ? (x / legnagyobb) * 100 : 0);
  return napi.map((n) => ({
    ...n,
    osszesen: n.megerositett + n.nem_megerositett,
    megerositettSzazalek: szaz(n.megerositett),
    nemSzazalek: szaz(n.nem_megerositett),
  }));
}

const HONAPOK = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];

/** „2026-10-01” → „okt. 1.” */
export function napCimke(nap: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(nap);
  const honap = m ? Number(m[2]) : 0;
  if (!m || honap < 1 || honap > 12) throw new RangeError(`Érvénytelen nap: ${nap}`);
  return `${HONAPOK[honap - 1]} ${Number(m[3])}.`;
}

/** Az első, a középső és az utolsó nap címkéje (egy napnál egy, üresnél nulla címke). */
export function tengelyCimkek(napi: readonly NapiAdat[]): string[] {
  if (napi.length === 0) return [];
  if (napi.length === 1) return [napCimke(napi[0]!.nap)];
  const indexek = [0, Math.floor((napi.length - 1) / 2), napi.length - 1];
  return indexek.map((i) => napCimke(napi[i]!.nap));
}
